import { FC } from 'react';
import { NumberField, Show, ShowProps, SimpleShowLayout } from 'react-admin';

const VPNShow: FC<ShowProps> = () => (
  <Show>
    <SimpleShowLayout>
      <NumberField source="id" />
    </SimpleShowLayout>
  </Show>
);

export default VPNShow;
